import PageHeader from "@modules/layout/components/page-header";
import { teamData } from "@data/teamData";
import { useTranslations } from "next-intl";
import { GetStaticPropsContext } from "next";
import Image from "next/image";
import Head from "@/modules/common/components/head";
import Footer from "@/modules/layout/templates/footer";
import Nav from "@/modules/layout/templates/nav";
import { useRouter } from "next/router";

const Management = () => {
  const t = useTranslations("Menu");
  const router = useRouter();
  const { locale } = router;
  return (
    <>
      <Head title={t(`board`)}></Head>
      <Nav />
      <PageHeader
        title={t(`bbs`)}
        sub={{ title: t(`about`), handle: "/about" }}
        image="https://d3leeb4r1qy96s.cloudfront.net/assets/WhatsApp56.jpeg"
      />
      <article className="page-body container page type-page status-publish hentry">
        <div className="container">
          <div className="max-w-4xl mx-auto space-y-8">
            {locale === "mn" ? (
              <img src="https://d3leeb4r1qy96s.cloudfront.net/assets/Picture2.png" alt="BBS" />
            ) : (
              <img src="https://d3leeb4r1qy96s.cloudfront.net/assets/Picture1.png" alt="BBS" />
            )}
            <h3 className="text-2xl font-semibold">{locale === "mn" ? "ББС ГЭЖ ЮУ ВЭ?" : "WHAT IS THE BBS?"}</h3>
            {/* BBS Definition */}
            <div className="bg-white rounded-lg p-6 shadow-md">
              {locale === "mn" ? (
                <p className="text-gray-700 leading-relaxed">
                  ББС бол байнгын сайжруулалт болон бизнес экселлэнсийн өндөр гүйцэтгэлийн соёлыг бий болгогч,
                  харилцагчдыг сэтгэл ханамжтай байлгах зорилго бүхий бизнесийн цогц систем юм. Бид Барловорлд болон
                  оролцогч талуудад шилдэг гүйцэтгэл, үр дүнг хүргэснээр хязгаарлалтыг даван гарахад зорьдог.
                </p>
              ) : (
                <p className="text-gray-700 leading-relaxed">
                  The BBS is a structured business operating system that enables a high-performance culture of both
                  continuous improvement and business excellence to delight our customers and sustainably create value
                  for our stakeholders. Our purpose is to defy limits by delivering breakthrough performance and results
                  for Barloworld and our stakeholders.
                </p>
              )}
            </div>

            {/* Key Pillars */}
            <div className="space-y-6">
              <h3 className="text-2xl font-semibold">
                {locale === "mn" ? "ББС ФИЛОСОФИЙН ГОЛ ТУЛГУУР:" : "THE KEY PILLARS OF THE BBS PHILOSOPHY ARE:"}
              </h3>

              {/* Respect for People */}
              <div className="bg-white rounded-lg p-6 shadow-md">
                <h4 className="text-xl font-semibold mb-4">
                  {locale === "mn" ? "Хүнийг хүндэтгэх:" : "RESPECT FOR PEOPLE:"}
                </h4>
                {locale === "mn" ? (
                  <p className="text-gray-700">
                    Итгэлцэл, хамтын ажиллагаа, оролцоог хангах замаар ажилтан, харилцагч, оролцогч талуудын үнэ цэн,
                    хувь нэмрийг үнэлэх явдлыг хөхиүлэн дэмждэг. Мөн ажилтнуудын ажил мэргэжлийн өсөлт хөгжил, сайн
                    сайхан байдал буюу well-being, оролцоонд анхаарна.
                  </p>
                ) : (
                  <p className="text-gray-700">
                    Valuing employees, customers, and stakeholders by fostering a culture of trust, collaboration, and
                    inclusivity. It involves empowering individuals, recognizing their contributions, and ensuring their
                    growth, well-being, and engagement in achieving organizational goals.
                  </p>
                )}
              </div>

              {/* Continuous Improvement */}
              <div className="bg-white rounded-lg p-6 shadow-md">
                <h4 className="text-xl font-semibold mb-4">
                  {locale === "mn" ? "Байнгын сайжруулалт:" : "CONTINUOUS IMPROVEMENT:"}
                </h4>
                {locale === "mn" ? (
                  <p className="text-gray-700">
                    Ажилтан бүрийг процесс, бүтээгдэхүүн, үйлчилгээ, систем дээрээ сайжруулалт хийх арга замыг байнга
                    эрэлхийлж байхыг хөхиүлэн дэмжинэ. Сайжруулалт хийхдээ үргүй зардлыг олж танин, асуудлыг
                    шийдвэрлэнэ. Жижиг жижгээр байнгын сайжруулалт хийх нь урт хугацааны тогтвортой өсөлт хөгжилтөд
                    хүргэдэг.
                  </p>
                ) : (
                  <p className="text-gray-700">
                    Consistently seeking ways to enhance processes, products, and services by identifying
                    inefficiencies, solving problems, and implementing better practices. It focuses on small,
                    incremental changes to achieve long-term excellence and sustainable growth.
                  </p>
                )}
              </div>
            </div>

            {/* Key Principles */}
            <div className="space-y-6">
              <h3 className="text-2xl font-semibold">
                {locale === "mn" ? "ББС-ИЙН ҮНДСЭН ЗАРЧИМ:" : "THE KEY PRINCIPLES OF THE BBS:"}
              </h3>
              <div className="bg-white rounded-lg p-6 shadow-md">
                <ul className="space-y-4 !list-none">
                  <li className="flex items-start ">
                    <p>{locale === "mn" ? "Харилцагч үнэ цэнийг тодорхойлно" : "The customer defines value"}</p>
                  </li>
                  <li className="flex items-start">
                    <p>
                      {locale === "mn"
                        ? "Үнэ цэнийг харилцагчийн хэрэгцээ шаардлагын дагуу, чанартай хүргэнэ"
                        : "Value to customers must be delivered on demand and right first time"}
                    </p>
                  </li>
                  <li className="flex items-start">
                    <p>
                      {locale === "mn"
                        ? "Процессыг үнэлэх ба сайжруулах, үргүй зардал ба гологдлыг арилгах шинэ арга барилыг нэвтрүүлж ажиллана"
                        : "A new way to evaluate and improve existing processes, removing waste and defects"}
                    </p>
                  </li>
                  <li className="flex items-start">
                    <p>
                      {locale === "mn"
                        ? "Процессыг гүйцэтгэх одоогоор мэдэгдэж буй хамгийн сайн арга замыг стандартчилах ба баримтжуулах шаардлагатай"
                        : "It demands that we standardize and document 'today's best-known way' of running a process"}
                    </p>
                  </li>
                  <li className="flex items-start">
                    <p>
                      {locale === "mn"
                        ? "Өдөр бүр тасралтгүй сайжруулах зорилгоор урагш тэмүүлэх хандлагыг бий болгодог"
                        : "Drives the ambition to continuously improve on a daily basis"}
                    </p>
                  </li>
                  <li className="flex items-start">
                    <p>
                      {locale === "mn"
                        ? "Харилцан хүндлэл болон хамтын хариуцлага нь өндөр гүйцэтгэлийг бий болгоно"
                        : "Mutual respect and shared responsibility enable higher performance"}
                    </p>
                  </li>
                  <li className="flex items-start">
                    <p>
                      {locale === "mn"
                        ? `Хувь хүн "хийх явцдаа суралцах" замаар гүн гүнзгий сурч хөгждөг`
                        : "Individuals go through a deep personal learning experience by 'learning as we do'"}
                    </p>
                  </li>
                  <li className="flex items-start">
                    <p>
                      {locale === "mn"
                        ? "Инновац болон шинэ бизнесийн загваруудыг нэвтрүүлэх замаар ажиллах шинэ хэв маягийг авчирдаг"
                        : "It brings in new ways of working through innovation and embracing new business models"}
                    </p>
                  </li>
                  <li className="flex items-start">
                    <p>
                      {locale === "mn"
                        ? "Байгууллагын манлайллын хэв маяг ба соёлын өөрчлөлтийг дэмждэг"
                        : "Drives a change in leadership style and culture in the organization"}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </article>
      <Footer />
    </>
  );
};

export default Management;

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  let messages;
  try {
    messages = (await import(`../../../messages/${locale}.json`)).default;
  } catch (error) {
    messages = {};
  }
  return {
    props: {
      messages,
    },
  };
}
